import { render, staticRenderFns } from "./ModalUserCreateOrInvit.vue?vue&type=template&id=31c8941f&scoped=true"
import script from "./ModalUserCreateOrInvit.vue?vue&type=script&lang=js"
export * from "./ModalUserCreateOrInvit.vue?vue&type=script&lang=js"
import style0 from "./ModalUserCreateOrInvit.vue?vue&type=style&index=0&id=31c8941f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8941f",
  null
  
)

export default component.exports